<div class="absolute inset-0 flex min-w-0 flex-col overflow-hidden">
    <mat-drawer-container class="bg-card h-full flex-auto dark:bg-transparent">
        <!-- Drawer -->
        <mat-drawer
            class="w-full dark:bg-gray-900 md:w-160"
            [mode]="'side'"
            [opened]="false"
            [position]="'end'"
            [disableClose]="false"
            #matDrawer
        >
            <vista-previa-documento [archivo]="archivoSeleccionado" (closeDrawer)="closeDrawer()"></vista-previa-documento>
        </mat-drawer>
        <mat-drawer-content class="flex flex-col">
           @if(informacionFichaRegistro$ | async; as ficha){
                <div class="w-full flex flex-col bg-white px-4 md:px-8 mb-4">
                    <!-- Header -->
                    <div class="flex flex-col md:flex-row  justify-between items-center py-3 border-b">

                        <!-- Title -->
                        <div class="flex flex-row items-start md:items-center w-full">
                        
                            <div class="flex-1 flex flex-col md:flex-row justify-between">
                                <div class="flex items-start md:items-center gap-2">
                                    <arrow-back></arrow-back>
                                    <div>
                                        <div class="text-2xl font-extrabold leading-7 tracking-tight sm:leading-10 md:text-4xl">{{ficha.bienCultural.noRegistro}} / {{ficha.bienCultural.titulo}}</div>
                                        <div class="ml-0.5 font-medium text-secondary mt-1">Fecha de registro: {{ficha.bienCultural.fechaCreacion | date }}</div>
                                    </div>
                                </div>
                                <div class="flex flex-wrap gap-2 justify-start md:justify-center md:items-end mt-2 md:mt-0">
                                    <div
                                        class="flex items-center justify-center w-auto max-w-52 px-4 rounded-full h-[30px] text-sm font-bold text-nowrap scale-95 md:scale-100"
                                        [ngStyle]="{
                                            'background-color': ficha.bienCultural.tipoBien.valor1, 
                                            'color':ficha.bienCultural.tipoBien.valor2
                                        }"
                                    >
                                        {{ ficha.bienCultural.tipoBien.descripcion }}
                                    </div>
                                    <div
                                        class="flex items-center justify-center w-auto max-w-56 px-4 rounded-full h-[30px] text-sm font-bold text-nowrap scale-95 md:scale-100"
                                        [ngStyle]="{
                                            'background-color': ficha.bienCultural.seccion.valor1, 
                                            'color':ficha.bienCultural.seccion.valor2

                                        }"
                                    >
                                        {{ ficha.bienCultural.seccion.descripcion }}
                                    </div>

                                    <button matButton [matMenuTriggerFor]="menu"
                                        class="flex items-center justify-center w-auto max-w-56 px-4 rounded-full h-[30px] text-sm font-bold text-nowrap scale-95 md:scale-100 bg-gray-500 text-white">
                                        Herramientas
                                    </button>
                                    <mat-menu #menu="matMenu">
                                        <button mat-menu-item 
                                            *hasPermissions="'generar_ficha_registro' ; modulos ['DetalleBienCultural']"
                                            (click)="agregarFichaRegistro(ficha.bienCultural.bienCulturalUuid)">
                                            <span>Generar Ficha de Registro</span>
                                        </button>
                                        @if(ficha.bienCultural.tipoBien.tipologiaId=== bienesInmuebles){
                                            <button mat-menu-item 
                                                *hasPermissions="'agregar_desmembracion_fraccionamiento' ; modulos ['DetalleBienCultural']"
                                                (click)="integracionesFraccionamiento(ficha.bienCultural, true)">
                                                <span>Agregar Desmembracion o Fraccionamiento</span>
                                            </button>
                                            <button mat-menu-item
                                                *hasPermissions="'agregar_elementos_conformantes' ; modulos ['DetalleBienCultural']"
                                                (click)="integracionesFraccionamiento(ficha.bienCultural, false)">
                                                <span>Agregar Elementos Conformantes</span>
                                            </button>
                                            <button mat-menu-item
                                                *hasPermissions="'actualizar_departamento_municipio' ; modulos ['DetalleBienCultural']"
                                                (click)="actualizarDepartamentoMunicipio(ficha.bienCultural)">
                                                <span>Actualizar Departamento y Municipio</span>
                                            </button>
                                            <button mat-menu-item
                                                *hasPermissions="'actualizar_coleccion' ; modulos ['DetalleBienCultural']"
                                                (click)="actualizarColeccion(ficha.bienCultural)">
                                                <span>Actualizar Colección</span>
                                            </button>
                                        }

                                        @if(ficha.bienCultural.tipoBien.tipologiaId===bienesMuebles){
                                            <button mat-menu-item 
                                                *hasPermissions="'administrar_piezas_por_lote' ; modulos ['DetalleBienCultural']"
                                                (click)="administrarPiezas(ficha.bienCultural.bienCulturalUuid, ficha.bienCultural.noRegistro)">
                                                <span>Administrar Piezas y Lotes de Bienes Muebles</span>
                                            </button>
                                            <button mat-menu-item 
                                                *hasPermissions="'registro_traspaso_coleccionistas' ; modulos ['DetalleBienCultural']"
                                                (click)="traspasoColeccionista(ficha.bienCultural)">
                                                <span>Registro de traspaso de coleccionistas</span>
                                            </button>
                                        }                             
                                        
                                    </mat-menu>
                                </div>
                            </div>
                        </div>

                    </div>

                <div class="flex flex-col">
                        <div class="flex flex-col md:flex-row gap-2 pt-2">
                            <image-card [image]="ficha.blobURL" class="hidden md:block"></image-card>
                            @if (ficha.blobURL) {
                                <image-card [image]="ficha.blobURL"  class="block md:hidden"></image-card>
                            }
                            <div class="hidden md:block md:flex-1">
                                <info-principal-bien-cultural [ficha]="ficha.bienCultural" [Archivos]="archivosGaleria$ | async"></info-principal-bien-cultural>
                            </div>
                            <mat-accordion class="flex-1 md:hidden">
                                <mat-expansion-panel>
                                    <mat-expansion-panel-header>
                                    <mat-panel-title>Información General</mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <info-principal-bien-cultural [ficha]="ficha.bienCultural" [Archivos]="archivosGaleria$ | async"></info-principal-bien-cultural>
                                </mat-expansion-panel>
                            </mat-accordion>
                        </div>

                        <div class="w-full flex-flex-col bg-white mt-3">
                            <mat-tab-group (selectedTabChange)="onTabChange($event)"
                                mat-stretch-tabs="false" mat-align-tabs="start" class="p-0">
                                <mat-tab label="Información Técnica" >
                                    <informacion-tecnica></informacion-tecnica>
                                </mat-tab>

                                <mat-tab label="Galeria">  
                                    <ng-template matTabContent>
                                        <bien-cultural-galeria [nombreFotografo]="ficha.bienCultural.fotografiaPor"></bien-cultural-galeria>
                                    </ng-template>
                                </mat-tab>

                                <mat-tab label="Ubicación">
                                    <ubicacion></ubicacion>
                                </mat-tab>

                                <mat-tab label="Procedencia" >
                                    <info-procedencia></info-procedencia>
                                </mat-tab>

                                <mat-tab label="Descripción" >
                                    <!--Tab para actualizar Descripción-->
                                    <descripcion-bien-cultural></descripcion-bien-cultural>
                                </mat-tab>

                                <mat-tab label="Documentos Emitidos" >
                                        <ng-template matTabContent>
                                            <documentos-emitidos 
                                                (abrirDrawer)="abrirDrawer($event)"
                                                [seccion]="ficha.bienCultural.seccion.tipologiaId">
                                            </documentos-emitidos>
                                        </ng-template>
                                </mat-tab>

                                <mat-tab>
                                    <ng-template mat-tab-label>
                                        <span>Gestiones Vinculadas</span>
                                    </ng-template>
                                    <ng-template matTabContent>
                                        <div class="overflow-x-auto">
                                            <elementos-vinculados 
                                                [elementosVinculados]="elementosVinculados$ | async"
                                                [link]="linkElementoVinculado"
                                            ></elementos-vinculados>
                                        </div>
                                    </ng-template>
                                </mat-tab>

                                
                                <mat-tab>
                                    <ng-template mat-tab-label>
                                        <span>Actividad</span>
                                    </ng-template>
                                    @if (this.actividadTareas$ | async; as actividades ) {
                                        <ng-container>
                                            <actividad-reciente [ActividadReciente]="actividades"></actividad-reciente>
                                        </ng-container>
                                    }
                                </mat-tab>

                                @if(ficha.bienCultural.tipoBien.tipologiaId === bienesInmuebles){
                                    <mat-tab label="Fraccionamiento / Elementos Conformantes" >
                                            <ng-template matTabContent>
                                                <fraccionamiento-integracion [ficha]="ficha.bienCultural"></fraccionamiento-integracion>
                                            </ng-template>
                                    </mat-tab>
                                }
                                
                            </mat-tab-group>

                        </div>
                </div>
                </div>
            }
        </mat-drawer-content>

    </mat-drawer-container>
</div>

